import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { LanguageCodes } from '@i18n/index';
import strings from '@i18n/index';
import { KEY } from '@consts/keys';

type LanguageCodeState = {
  code: LanguageCodes;
  changeLanguageCode: (lan: LanguageCodes) => void;
};

const useLanguageCodeStore = create<LanguageCodeState>()(
  devtools(
    persist(
      (set) => ({
        code: 'ko',
        changeLanguageCode: (lan) => {
          localStorage.setItem(KEY.LANGUAGE, lan);
          strings.setLanguage(lan);
          set(() => ({
            code: lan,
          }));
        },
      }),
      { name: 'LANGUAGE_CODE_KEY' },
    ),
  ),
);

export default useLanguageCodeStore;
